import React from 'react';
import ChartistGraph from 'react-chartist';
import "../../components/player-overview-charts/chartist.min.css";
import "./player_progress_chart.css";


class PlayerProgressChart extends React.Component {

    prepareData(data) {
        let datesArray = [];
        let dataPoints = [];
        for (let key in data) {
            datesArray.push(key);
        }

        datesArray.sort(function(a, b) { return a < b;});

        for (let index in datesArray) {
            let date = datesArray[index];  
            dataPoints.push(data[date]);

            date = date.substr(5);
            datesArray[index] = date;
        }

        return [datesArray, dataPoints];

    }

    render() {
        let {data} = this.props;

        let actualData = data[0];
        let title = data[1];
        
        
        let graphTitle = title[0];
        let funcType = title[2];
        let gameImagePath = title[3];
        let yAxisTitle = title[1];
        let parsedData = this.prepareData(actualData);

        if (!parsedData[1] || parsedData[1].length === 0) {
            return "";
        }
        const graphDataParsed = {
            labels: parsedData[0],
            series: [parsedData[1]]
          };
  
          const options = {
              low: 0,              
              showLabels: true
          };
        

        const type = 'Line';

        let indicatorClassName = "func_type_indicator " + funcType;

        let chartClassName = "daily_progress_line_chart " + funcType;
        return (
            <div className='player_progress_chart'>                
                <div className='player_progress_chart_title'>{graphTitle}</div>
                <img className='player_progress_chart_game_image' alt="game_icon" src={require(`../../../static/assets/game_icons/${gameImagePath}`)} />
                <div className='player_progress_chart_container'>
                    <div className='y_axis_title'>{yAxisTitle} <span className={indicatorClassName}>({funcType})</span></div>
                    <ChartistGraph className={chartClassName} data={graphDataParsed} options={options} type={type}/>
                    <div className ='x_axis_title'>Date</div> 
                </div>
            </div>
        );
    }
}


export default PlayerProgressChart;


// WEBPACK FOOTER //
// ./src/components/containers/player-progress-dashboard/player_progress_chart.js